import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as TyreReregistrationOrderModels from '../../models/tyre-reregistration-order/tyre-reregistration-order';
import { TyreReregistrationOrderSearchModel } from '../../models/tyre-reregistration-order/tyre-reregistration-orderSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as Models from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})

export class TyreReregistrationOrderService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService) { }

  public getList(Search: TyreReregistrationOrderSearchModel) {

      const httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Cache-Control', 'no-cache');

      Search.RequestSignature = Math.random();

      const options = { headers: httpHeaders };

      return this.httpClient.post<TyreReregistrationOrderModels.TyreReregistrationOrderListModel>(`${this.environmentService.getApiURL()}/tyre-reregistration-order/list`, Search, options);
    }

  public getStatusDictionary() {
      return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/tyre-reregistration-order/status`);
    }

  public getFilteredReport(Search: TyreReregistrationOrderSearchModel) {
      const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

      const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
      return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/tyre-reregistration-order/report/filtered`, Search, options);
    }

  public set(TyreReregistrationOrder: Models.Request<TyreReregistrationOrderModels.TyreReregistrationOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreReregistrationOrderModels.TyreReregistrationOrderModel>>(`${this.environmentService.getApiURL()}/tyre-reregistration-order/set`, TyreReregistrationOrder, options);
  }

  public get(TyreReregistrationOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreReregistrationOrderModels.TyreReregistrationOrderModel>>(`${this.environmentService.getApiURL()}/tyre-reregistration-order/get`, TyreReregistrationOrder, options);
  }
}
